<template>
  <div>


    <router-view/>
  </div>
</template>
<script>
export default {
  name: "app"
};
</script>
import Vuex from 'vuex';

Vue.use(Vuex);
 const store = new Vuex.Store({
  state: {
    employeeId: ''
  }
});

<style lang="scss">

</style>
